import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Alert,
    Backdrop,
    Box,
    Button,
    CircularProgress,
    FormControl,
    FormHelperText,
    Grid,
    Grow,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Typography,
    useMediaQuery
} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthCardWrapper from '../AuthCardWrapper';
import AuthFooter from 'ui-component/cards/AuthFooter';
import AuthNavbar from 'layout/Navbar/AuthNavbar';
import { baseUrl } from 'store/baseurl';

const ResetPassword = ({ ...others }) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const key = searchParams.get('key');
    const theme = useTheme();
    const scriptedRef = useScriptRef();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const customization = useSelector((state) => state.customization);
    // Now you can access the ClientId property
    const [NewPassword, setNewPassword] = useState("");
    const [cnfPassword, setCnfPassword] = useState("");
    const [errorMessage, setMessage] = useState("");
    const [SuccessMessage, setSuccessMessage] = useState("");
    const [ClientInfo, setClientInfo] = useState("");

    const [IsExist, setIsExist] = useState(false);

    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [open, setOpen] = useState(true);

    //Backdrop //blockUI
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        fetch(`${baseUrl}api/client/resetpassword?key=${key}`, {
            method: 'Get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                console.log(response);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(apiData => {
                //setData(apiData); 
                console.log(apiData);
                if (apiData.success == true) {
                    setClientInfo(apiData.data);
                    handleClose();
                }
                else {
                    setMessage(apiData.message);
                    handleClose();
                }
            })
            .catch(error => {
                console.log(error)
            })

    }, [])


    return (
        <>

            <AuthNavbar />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
                onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                    <AuthCardWrapper>
                        <Grid item xs={12} container alignItems="center" justifyContent="center">
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle1">Reset your Password</Typography>
                            </Box>
                        </Grid>
                        {IsExist == true ?
                            <Grid item xs={12} container alignItems="center" justifyContent="center" className='my-2'>
                                {SuccessMessage &&
                                    <Grow
                                        in={IsExist}
                                        style={{ transformOrigin: '0 0 0' }}
                                        {...(IsExist ? { timeout: 1000 } : {})}
                                    >
                                        <Alert severity="success" onClose={() => { setIsExist(false) }}> {SuccessMessage} </Alert>
                                    </Grow>
                                }
                                {errorMessage &&
                                    <Grow
                                        in={IsExist}
                                        style={{ transformOrigin: '0 0 0' }}
                                        {...(IsExist ? { timeout: 1000 } : {})}
                                    >
                                        <Alert severity='error' onClose={() => { setIsExist(false) }}>{errorMessage}</Alert>
                                    </Grow>
                                }
                            </Grid>
                            : null}
                        {ClientInfo ? (
                            <Formik
                                initialValues={{
                                    newPassword: NewPassword,
                                    cnfPassword: cnfPassword,
                                    submit: null
                                    //onSubmit:{onSubmitMethod}
                                }}
                                validationSchema={Yup.object().shape({
                                    newPassword: Yup.string().max(20).required('Password is required')
                                        .matches(/^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/, ' Password must contain at least 1 capital letter, 1 special character and minimum 8 characters in length.'),
                                    cnfPassword: Yup.string().max(20).required('Confirm Password is required')
                                })}
                                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                                    if (values.newPassword != values.cnfPassword) {
                                        setStatus({ success: false });
                                        setSubmitting(false);
                                        setErrors({ submit: "New Password and Confirm Password should be same." })
                                    }
                                    else {
                                        try {
                                            if (scriptedRef.current) {
                                                setStatus({ success: true });
                                                setSubmitting(false);
                                            }
                                        } catch (err) {
                                            console.error(err);
                                            if (scriptedRef.current) {
                                                setStatus({ success: false });
                                                setErrors({ submit: err.message });
                                                setSubmitting(false);
                                            }
                                        }
                                        debugger;
                                        //console.log(this.state)
                                        fetch(`${baseUrl}api/client/resetpassword`, {
                                            method: 'POST',
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json',
                                            },
                                            body: JSON.stringify({
                                                clientid: ClientInfo.ClientId,
                                                newpassword: values.newPassword,
                                                confirmpassword: values.cnfPassword,
                                            })
                                        })
                                            .then(response => {
                                                console.log(response);
                                                if (!response.ok) {
                                                    setIsExist(true)
                                                    if (response.status === 500) {
                                                        setIsExist(true)
                                                        setMessage('Server error ! Please try again.')
                                                    }
                                                    else if (response.status === 401) {
                                                        navigate("/login", { state: 'Expired' })
                                                    }
                                                    else if (response.status === 403) {
                                                        navigate("/login", { state: 'Expired' })
                                                    }
                                                    throw new Error('Network response was not ok');
                                                }
                                                return response.json();
                                            })
                                            .then(apiData => {
                                                //setData(apiData);
                                                console.log(apiData);
                                                setIsExist(true);
                                                if (apiData.success == true) {
                                                    setSuccessMessage(apiData.message);
                                                }
                                                else {
                                                    setMessage(apiData.message);
                                                }
                                            })
                                            .catch(error => {
                                                console.log(error)
                                            })
                                    }
                                }
                                }
                            >
                                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                                    <form noValidate onSubmit={handleSubmit} {...others}>
                                        <FormControl fullWidth error={Boolean(touched.newPassword && errors.newPassword)} sx={{ ...theme.typography.customInput }}>
                                            <InputLabel htmlFor="outlined-adornment-newPassword-change"> Password</InputLabel>
                                            <OutlinedInput
                                                id="outlined-adornment-newPassword-change"
                                                type={'password'}
                                                value={values.newPassword}
                                                name="newPassword"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                label="New Password"
                                                inputProps={{}}
                                            />
                                            {touched.newPassword && errors.newPassword && (
                                                <FormHelperText error id="standard-weight-helper-text-password-login">
                                                    {errors.newPassword}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                        <FormControl fullWidth error={Boolean(touched.cnfPassword && errors.cnfPassword)} sx={{ ...theme.typography.customInput }}>
                                            <InputLabel htmlFor="outlined-adornment-cnfPassword-change">Confirm Password</InputLabel>
                                            <OutlinedInput
                                                id="outlined-adornment-cnfPassword-change"
                                                type={showPassword ? 'text' : 'password'}
                                                value={values.cnfPassword}
                                                name="cnfPassword"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            edge="end"
                                                            size="large"
                                                        >
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                                label="Password"
                                                inputProps={{}}
                                            />
                                            {touched.cnfPassword && errors.cnfPassword && (
                                                <FormHelperText error id="standard-weight-helper-text-cnfPassword-change">
                                                    {errors.cnfPassword}
                                                </FormHelperText>
                                            )}
                                        </FormControl>

                                        {errors.submit && (
                                            <Box sx={{ mt: 3 }}>
                                                <FormHelperText error>{errors.submit}</FormHelperText>
                                            </Box>
                                        )}
                                        <Box sx={{ mt: 2 }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <AnimateButton>
                                                        <Button disableElevation disabled={isSubmitting} fullWidth size="large" type="submit" variant="contained" color="secondary">
                                                            Submit
                                                        </Button>
                                                    </AnimateButton>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <AnimateButton>
                                                        <Button disableElevation disabled={isSubmitting} fullWidth size="large" type="button" onClick={() => { navigate('/login') }} variant="contained" color="secondary">
                                                            Back to Login
                                                        </Button>
                                                    </AnimateButton>
                                                </Grid>
                                            </Grid>


                                        </Box>
                                    </form>
                                )}
                            </Formik>
                        ) : (<Grid>Some thing went wrong <Button onClick={() => { navigate('/login') }}>Back to login</Button></Grid>)}

                    </AuthCardWrapper>
                </Grid>
            </Grid>
            <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
                <AuthFooter />
            </Grid>
        </>
    );
};

export default ResetPassword;
